/* Mobile carousel dots for .pe-carousel (<=600px). Pair each carousel with the next .pe-dots sibling. */
(function () {
  if (window.__peCarousel) return;
  window.__peCarousel = true;
  var MQ = window.matchMedia('(max-width: 600px)');
  function setup(car) {
    if (car.__peDots) { car.__peDots.refresh(); return; }
    var dotsEl = car.parentNode && car.parentNode.querySelector('.pe-dots[data-for="' + (car.id || '') + '"]');
    if (!dotsEl) { var n = car.nextElementSibling; if (n && n.classList.contains('pe-dots')) dotsEl = n; }
    if (!dotsEl) return;
    var api = { refresh: build };
    car.__peDots = api;
    var io = null;
    function build() {
      dotsEl.innerHTML = '';
      if (io) { io.disconnect(); io = null; }
      if (!MQ.matches) return;
      var items = [].slice.call(car.children).filter(function (el) { return el.classList.contains('pe-slide'); });
      if (items.length < 2) return;
      var dots = items.map(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'pe-dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Slide ' + (i + 1));
        d.addEventListener('click', function () { items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); });
        dotsEl.appendChild(d); return d;
      });
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var idx = items.indexOf(e.target);
            dots.forEach(function (d, di) { d.classList.toggle('is-active', di === idx); });
          }
        });
      }, { root: car, threshold: 0.6 });
      items.forEach(function (it) { io.observe(it); });
    }
    build();
  }
  function init() { [].forEach.call(document.querySelectorAll('.pe-carousel'), setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  (MQ.addEventListener ? MQ.addEventListener.bind(MQ, 'change') : MQ.addListener.bind(MQ))(function () { init(); });
})();
